<div class="addresses-section" [class.addresses-section--scrollable]="scrollable">
  <div class="addresses-section__header">
    <h4>{{ title }}</h4>
    <button pButton type="button" severity="secondary" [disabled]="disabled" (click)="onAddAddress()">
      <span class="pi pi-plus" aria-hidden="true"></span>
      <span>{{ addButtonLabel }}</span>
    </button>
  </div>

  <div class="addresses-list" [class.addresses-list--scrollable]="scrollable">
    @for (addressGroup of addressesArray.controls; track addressGroup; let i = $index) {
      <div
        class="address-row"
        [formGroup]="addressGroup"
        [animate.enter]="rowMotionEnabled ? 'address-row-enter' : null"
        [animate.leave]="rowMotionEnabled ? 'address-row-leave' : null"
      >
        <div class="address-row__fields">
          <app-form-field
            label="Numer budynku"
            [disabled]="disabled"
          >
            <input
              pInputText
              formFieldControl
              [id]="getFieldId('buildingNumber', i)"
              formControlName="buildingNumber"
              placeholder="np. 12A"
              class="w-full"
            />
          </app-form-field>

          <app-form-field
            label="Klatka / wejście"
            [disabled]="disabled"
          >
            <input
              pInputText
              formFieldControl
              [id]="getFieldId('entranceCode', i)"
              formControlName="entranceCode"
              placeholder="np. A"
              class="w-full"
            />
          </app-form-field>
        </div>

        <button
          pButton
          type="button"
          severity="secondary"
          [text]="true"
          [disabled]="!canRemoveAddress(i)"
          [pTooltip]="!canRemoveAddress(i) ? removeDisabledTooltip : undefined"
          tooltipPosition="top"
          (click)="onRemoveAddress(i)"
        >
          <span class="pi pi-times" aria-hidden="true"></span>
          <span>{{ removeButtonLabel }}</span>
        </button>
      </div>
    }
  </div>

  @if (addressesArray.length === 0) {
    <p-message severity="warn">{{ emptyMessage }}</p-message>
  }
</div>
